export default {
  when: function () {
    return Promise.resolve();
  },
  all: function (promises) {
    return Promise.all(promises);
  },
  defer: function () {
    let resolve, reject;
    const promise = new Promise((resolvePromise, rejectPromise) => {
      resolve = resolvePromise;
      reject = rejectPromise;
    });

    return {
      resolve,
      reject,
      promise,
    };
  },
};
